var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-modal',_vm._g(_vm._b({attrs:{"name":"mediacontact-product-type-create","title":"Produktart erstellen","width":400}},'base-modal',_vm.$attrs,false),_vm.$listeners),[_c('mediacontact-product-type-form',{attrs:{"mediacontactProductType":_vm.mediacontactProductType,"type":"create"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }